import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import Progressbar from "../../Components/Progressbar";

/** Components Import */
import ST10040View from "../../Views/Stock/ST10040";
import Snackbar from "../../Components/Snackbar";
import { Landscape } from "@mui/icons-material";

function ST10040(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({
    processList: [],
    barcodeValue: "",
  });
  const [rowData, setRowData] = React.useState([]);
  const [itemType, setItemType] = React.useState([
    {
      plantCd: "",
      itemType: "",
    },
  ]);
  const [progress, setProgressbar] = React.useState(false);
  const [checkInputs1, setCheckInputs1] = React.useState({
    value1: "",
    value2: "",
    value3: "",
    itemType: "",
  });
  const [checkInputs2, setCheckInputs2] = React.useState({
    value1: "",
    value2: "",
    value3: "",
    whCd: "WH_MM_03",
    moveWhCd: "WH_MM_01",
  });
  // 품목타입 콤보박스
  const [whType, setWhType] = React.useState([]); //창고타입 콤보박스
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [stockData, setStockData] = React.useState([]);
  const [startDate, setStartDate] = React.useState(new Date());
  const [authGroupGridRowData1, setAuthGroupGridRowData1] = React.useState([]);
  const [lanData, setLanData] = React.useState([]);

  const [checkInputs, setCheckInputs] = React.useState({
    itemCd: "",
    itemNm: "",
    whCd: "WH_IN_01",
    itemQty: 0,
    plantCd: "P100",
    comboList: [],
    comboInwh: [], //창고
    comboWhCd: [], //재고이동 안 창고
    comboMoveWhCd: [], //재고이동 안 이동창고
  });
  React.useEffect(() => {
    let getLanData = [];

    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    const SearchLogic = async () => {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
    };

    CmItemType();
    SearchLogic();
  }, []);

  //바코드조회
  const BarcodeScan = async (_value, _whCd) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let getData = [];

    try {
      for (let i = 0; i < stockData.length; i++) {
        if (stockData[i].lotNo === _value) {
          setSnackbars({
            toggle: true,
            type: "error",
            message: "바코드중복",
          });
          setInputs({ ...inputs, barcodeValue: "" });
          return false;
        }
      }
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10040.GetStockList,
        {
          value: _value == "" ? "string" : _value,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
          // setStockData([]);
          setInputs({ ...inputs, barcodeValue: "" });
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              plantCd: data[i].plantCd,
              lotNo: data[i].lotNo,
              itemNm: data[i].itemNm,
              itemCd: data[i].itemCd,
              stockQty: data[i].stockQty,
              whCd: data[i].whCd,
              whCd2: data[i].whCd2,
            });
          }
          getData = getData.filter((e) => e.stockQty > 0);
          setStockData([
            ...stockData,
            {
              plantCd: data[0].plantCd,
              lotNo: data[0].lotNo,
              itemNm: data[0].itemNm,
              itemCd: data[0].itemCd,
              stockQty: data[0].stockQty,
              whCd: data[0].whCd,
              whCd2: data[0].whCd2,
            },
          ]);
          setInputs({ ...inputs, barcodeValue: "" });
        }
      });
    } catch (e) {
      console.log(e);
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };

  //재고이동
  const MoveWhCdStock = async (_moveData) => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let userInfo = null;
    let postData = [];
    try {
      for (let i = 0; i < _moveData.length; i++) {
        _moveData[i].whCd = _moveData[i].whCd2;
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Stock.ST10030.UpdateMoveStock,
        { whFromCd: checkInputs2.moveWhCd },
        _moveData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_MoveStock" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setStockData([]);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };
  //창고코드
  const CmItemType = async (_custCd = "") => {
    // Dialog.ProgressBar(true);
    setProgressbar(true);

    let getComboData = [];
    let getComboData1 = [];
    let getComboData2 = [];
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetItemList,
        {
          plantCd: "string",
          value: "string",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.type === "데이터가 없습니다.") {
          throw new Error(data.message);
        } else {
          for (let i = 0; i < data.length; i++) {
            getComboData1.push({
              plantCd: data[i].plantCd,
              name: data[i].itemNm,
              value: data[i].itemCd,
            });
          }
          setItemType(Commons.InsertNumber(getComboData1));
        }
      });
      //창고코드 콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh,
        {
          whCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData2.push({
            value: data[i].value,
            name: data[i].name,
          });
        }
        checkInputs.comboWhCd = getComboData2.filter(
          (e) => e.value.substring(0, 5) == "WH_MM"
        );
        checkInputs.comboMoveWhCd = getComboData2.filter(
          (e) => e.value.substring(0, 5) == "WH_MM"
        );
        setWhType(getComboData2);
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          throw new Error(data);
        } else if (data.type === "데이터가 없습니다.") {
          throw new Error(data.message);
        } else {
          for (let i = 0; i < data.length; i++) {
            getComboData.push({
              groupCd: data[i].GroupCd,
              name: data[i].Name,
              value: data[i].Code,
            });
          }

          checkInputs.comboList = getComboData.filter(
            (e) => e.groupCd == "ITEM_TYPE"
          );

          checkInputs.comboInwh = getComboData.filter(
            (e) => e.groupCd == "WH_CD"
          );
          // setWhType(Commons.InsertNumber(checkInputs.comboInwh));
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      // Dialog.ProgressBar(false);
      setProgressbar(false);
    }
  };
  return (
    <>
      <ST10040View
        rowData={rowData}
        setRowData={setRowData}
        itemType={itemType}
        setItemType={setItemType}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        CmItemType={CmItemType}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        setAuthGroupGridRowData1={setAuthGroupGridRowData1}
        authGroupGridRowData1={authGroupGridRowData1}
        startDate={startDate}
        setStartDate={setStartDate}
        checkInputs1={checkInputs1}
        stockData={stockData}
        MoveWhCdStock={MoveWhCdStock}
        setStockData={setStockData}
        setCheckInputs1={setCheckInputs1}
        checkInputs2={checkInputs2}
        setCheckInputs2={setCheckInputs2}
        whType={whType}
        lanData={lanData}
        inputs={inputs}
        setInputs={setInputs}
        BarcodeScan={BarcodeScan}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
      <Progressbar value={progress} />
    </>
  );
}

export default ST10040;
